export const service_url = {
  api_url: 'https://api.wearable.riseplus.tech',
}

